// ----------------------------------------------------------------------------
// Product Gallery Module: Product Zoom
// ----------------------------------------------------------------------------
// The ProductZoom class enables "zoom on hover" for images in the media gallery
// - Depends on Drift.js (https://github.com/strawdynamics/drift)
// ----------------------------------------------------------------------------
// Event Listeners:
// - 'productForm:gallery:init' → Initializes zoom when the product gallery is ready
// ----------------------------------------------------------------------------
// Gotchas:
// - Zoom is only enabled if `data-zoom-effect="true"` is set on the gallery element.
// - The zoom effect is only applied on devices with a pointer (not touchscreens) and screen width > 1023px.
// - Drift.js is initialized for each `.js--image-zoom` element, using `.product__feature-image` as the pane container.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import Drift from 'drift-zoom';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';

// -------------------------------------
// Product Zoom Class
// -------------------------------------

class ProductZoom {
  constructor(iamProductGallery) {
    // Reference to parent
    this.iamProductGallery = iamProductGallery;

    // Initialize Zoom
    // TODO: Do we need this, or can we just remove productZoom.js from product-gallery.js when not needed?
    // i.e. does it potentially vary by product?
    if (iamProductGallery.dataset.zoomEffect === 'true') {
      this.initZoom();
    }
  }

  /**
   * Initialize the image zoom effect
   */
  initZoom() {
    if (matchMedia('(pointer:fine)').matches && window.innerWidth > 1023) {
      var driftImgs = this.iamProductGallery.querySelectorAll('.js--image-zoom');
      var pane = this.iamProductGallery.querySelector('.product__feature-image');

      // Documentation: https://github.com/strawdynamics/drift#basic-usage
      driftImgs.forEach(image => {
        new Drift(image, {
          paneContainer: pane,
          inlinePane: false,
          handleTouch: false,
          injectBaseStyles: true,
          hoverDelay: 200
        });
      });
    }
  }
}
var productZoomControllers = [];
iamotaEventHandler.subscribe('productForm:gallery:init', _ref => {
  var iamProductGallery = _ref.iamProductGallery;
  productZoomControllers.push(new ProductZoom(iamProductGallery));
}, {
  source: "productZoom.js"
});
export default productZoomControllers;